import { Card } from '../../../../../../../components/card/card';
import { Container } from '../../../../../../../components/container/container';
import { InputFileSquare } from '../../../../../../../components/input-file/input-file-square/input-file-square';
import { Input } from '../../../../../../../components/input/input';
import { DateTimeRange } from '../../../../../../../features/date-time/datetime-range/datetime-range';
import { Editor } from '../../../../../../../features/editor/editor';
import { LangInput } from '../../../../../../../features/lang-input/lang-input';
import { MultiSelect } from '../../../../../../../features/multi-select/multi-select';
import { formatToBackDateTime } from '../../../../../../../helpers/date-time';
import { LangType } from '../../../../../../../helpers/lang';
import s from './promo-settings.module.css';
import { usePromoSettings } from './use-promo-settings';

export const PromoSettings = () => {
  const {
    promo,
    handleChangeImage,
    handleMaxSizeError,
    handleUpdatePromo,
    isLoading,
    t,
    nestedPlaces,
    handleChangeBranches,
    selectedPlaces,
    currentLang,
  } = usePromoSettings();
  const src = promo?.image?.ru || undefined;

  return (
    <Card className={s.feature} title={`1. ${t('Настройки')}`} withLang>
      <Container label={t('Филиалы')} required>
        <MultiSelect
          onSelect={handleChangeBranches}
          options={nestedPlaces}
          value={selectedPlaces}
          name="branches"
          data-testid="branches-input"
        />
      </Container>

      <Container required label={t('Название')}>
        <LangInput
          value={promo?.name}
          onChange={(e) => handleUpdatePromo({ name: e })}
          name="name"
          data-testid="name-input"
        />
      </Container>

      <Container label={t('Описание')}>
        <LangInput
          value={promo?.description}
          onChange={(e) => handleUpdatePromo({ description: e })}
          data-testid="description-input"
        />
      </Container>

      <DateTimeRange
        onChangeFrom={(e) => handleUpdatePromo({ active_from: formatToBackDateTime(e) })}
        onChangeTo={(e) => handleUpdatePromo({ active_to: formatToBackDateTime(e) })}
        minDate={new Date()}
        fromValue={promo?.active_from}
        toValue={promo?.active_to}
        name="promo"
        data-testid="date-time-range-input"
      />

      <Container label={t('Изображение(не более 2Мб)')} required>
        <InputFileSquare
          types={['image/*']}
          src={src}
          wrapperClassName={s.image}
          onChange={handleChangeImage}
          isLoading={isLoading}
          maxFileSizeInMb={2048}
          onFileSizeError={handleMaxSizeError}
          name="img"
          deletable={!!src}
          data-testid="image-input"
        />
      </Container>
      <Container label={t('Условия акции')}>
        <Editor
          value={promo?.condition}
          onChange={(e) => handleUpdatePromo({ condition: e as LangType })}
        />
      </Container>

      <Container label={t('Наименование ссылки')}>
        <Input
          value={promo?.media?.[currentLang]?.caption}
          onChange={(e) =>
            handleUpdatePromo({
              media: {
                ...(promo?.media ?? {}),
                [currentLang]: { caption: e.currentTarget.value, link: promo?.link ?? '' },
              },
            })
          }
          data-testid="link-input"
        />
      </Container>

      <Container label={t('Ссылка')}>
        <Input
          value={promo?.media?.[currentLang]?.link || ''}
          onChange={(e) =>
            handleUpdatePromo({
              media: {
                ...(promo?.media ?? {}),
                [currentLang]: {
                  caption: promo?.media?.[currentLang]?.caption ?? '',
                  link: e.currentTarget.value,
                },
              },
            })
          }
          data-testid="link-input"
        />
      </Container>
    </Card>
  );
};
